import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';

export class ApiSource {
  constructor(private http: HttpClient, private host: string, private type: string) {}

  load(lang: string): Observable<any> {
    return this.http
      .get(`${this.host}/${this.type}/${lang}.json`)
      .pipe(catchError(() => of({})));
  }
}